// src/components/Dashboard/DashboardNavbarAdmin.jsx 
import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";

const DashboardNavbarAdmin = ({
  displayName = "Admin",
  roleLabel = "Administrator",
  pageTitle = "Admin Panel", // masih ada prop, tapi nggak ditampilkan
}) => {
  const [monthlyRevenue, setMonthlyRevenue] = useState(0);
  const [loadingRevenue, setLoadingRevenue] = useState(true);

  useEffect(() => {
    const fetchMonthlyRevenue = async () => {
      try {
        setLoadingRevenue(true);

        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const startOfNextMonth = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          1
        );

        const { data, error } = await supabase
          .from("transactions")
          .select("amount_paid, duitku_fee, status, paid_at")
          .gte("paid_at", startOfMonth.toISOString())
          .lt("paid_at", startOfNextMonth.toISOString())
          .eq("status", "paid"); // sesuaikan dengan status sukses di DB-mu

        if (error) {
          console.error("Error fetching monthly revenue:", error);
          setMonthlyRevenue(0);
        } else {
          const total = (data || []).reduce((sum, row) => {
            const amount = Number(row.amount_paid || 0);
            const fee = Number(row.duitku_fee || 0);
            return sum + (amount - fee); // net revenue
          }, 0);
          setMonthlyRevenue(total);
        }
      } catch (err) {
        console.error("Error in fetchMonthlyRevenue:", err);
        setMonthlyRevenue(0);
      } finally {
        setLoadingRevenue(false);
      }
    };

    fetchMonthlyRevenue();
  }, []);

  const formatRupiah = (value) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(value || 0);

  const monthName = new Date().toLocaleDateString("id-ID", {
    month: "long",
    year: "numeric",
  });

  const handleToggleSidebar = () => {
    window.dispatchEvent(new CustomEvent("toggle-dashboard-sidebar"));
  };

  return (
    <header
      className="
        h-14 md:h-16
        bg-gradient-to-r from-sky-50 via-white to-indigo-50
        border-b border-slate-200/80
        backdrop-blur-md
        px-3 md:px-5
        flex items-center justify-end
        shadow-sm
      "
    >
      {/* RIGHT: pendapatan + user + burger */}
      <div className="flex items-center gap-2 md:gap-3">
        {/* Badge pendapatan (desktop) */}
        {/* Pendapatan bulan ini (desktop, super clean) */}
        <div className="hidden md:flex flex-col items-end leading-tight mr-2">
          <span className="text-[10px] uppercase tracking-wide text-slate-400">
            Pendapatan bulan ini · {monthName}
          </span>
          <span className="text-[13px] font-semibold text-sky-700">
            {loadingRevenue ? "Memuat..." : formatRupiah(monthlyRevenue)}
          </span>
        </div>


        {/* Mobile: pendapatan ringkas */}
        <div className="flex md:hidden flex-col items-end leading-tight">
          <span className="text-[10px] font-semibold text-slate-800">
            {loadingRevenue ? "Pendapatan..." : formatRupiah(monthlyRevenue)}
          </span>
          <span className="text-[9px] text-slate-500">{monthName}</span>
        </div>

        {/* Info admin (desktop) */}
        <div className="hidden md:flex flex-col items-end leading-tight">
          <span className="text-[13px] font-semibold text-slate-800">
            {displayName}
          </span>
          <span className="text-[11px] text-slate-500">{roleLabel}</span>
        </div>

        {/* Avatar (desktop) */}
        <div className="hidden md:flex w-9 h-9 rounded-full bg-sky-600 text-white items-center justify-center text-sm font-bold">
          {displayName?.charAt(0)?.toUpperCase() || "A"}
        </div>

        {/* Burger button (mobile) */}
        <button
          type="button"
          className="
            md:hidden
            p-1.5
            rounded-xl
            border border-slate-200
            bg-white/80
            text-slate-600
            hover:bg-slate-50
            active:scale-95
            shadow-sm
            transition
          "
          onClick={handleToggleSidebar}
          aria-label="Buka menu sidebar admin"
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              d="M4 6h16M4 12h16M4 18h16"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default DashboardNavbarAdmin;
